import { create } from 'zustand';

const useMarketStructureAnalysisStore = create((set) => ({
  analysis: null,
  isLoading: false,
  error: null,
  lastUpdated: null,

  setLoading: (isLoading = true) =>
    set({
      isLoading,
      error: null,
    }),

  setAnalysis: (analysis) =>
    set({
      analysis,
      isLoading: false,
      error: null,
      lastUpdated: new Date().toISOString(),
    }),

  setError: (error) =>
    set({
      error: error || 'Unable to load market structure analysis.',
      isLoading: false,
    }),

  clearAnalysis: () =>
    set({
      analysis: null,
      isLoading: false,
      error: null,
      lastUpdated: null,
    }),
}));

export default useMarketStructureAnalysisStore;